// /terms is kept so old links, bookmarks and the App Store listing still
// work: on the web it replaces itself with the central Dive Deep Dialogues
// terms; inside the iOS app it opens them in the in-app browser sheet and
// returns to where the reader was.
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { openLegalPage } from '../../config/legalLinks';

const LegalRedirect = ({ to, label }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      openLegalPage(to);
      navigate(-1);
    } else {
      window.location.replace(to);
    }
  }, [to, navigate]);
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 pt-28">
      <p className="text-slate-300">
        Taking you to the <a href={to} className="text-amber-300 underline">{label}</a>.
      </p>
    </div>
  );
};

export default LegalRedirect;
